import type { IMessageWriter } from '../../../engine/messageWriter'
import { getIsHost } from '../../../engine/websockets'
import { common } from '../../../main/common-sidecar'
import { voyageCamera } from '../voyageCamera-sidecar'
import { voyageMultiplayerCursors } from '../voyageMultiplayerCursors-sidecar'
import { voyageUiMessage } from '../voyageUiMessage-sidecar'
import { voyageMessageCursor } from './voyageMessageCursor-sidecar'
import { voyageMessages } from './voyageMessages-sidecar'

//TODO: move these to extension file and add bulk of this file to engine
export function extension_getLocalServerAddress() {
  return 'ws://localhost:8901' // TODO: new chess server
}
export function extension_getRemoteServerAddress() {
  // return 'wss://ws-voyage.keepflyinggames.com' // TODO: new chess server
  return 'wss://ws-keepflyingtogether.keepflyinggames.com'
}
export function extension_onMeJoin() {
  // chessGameManager.goGame()
  // if (getIsHost()) {
  //   console.log('!! I am host RESET WORLD')
  //   chessMessageHostCommand.sendMessageAndImmediatelyExecute({
  //     command: EChessHostCommand.Reset,
  //   })
  // }
}
export function extension_onOtherJoin(multiId: number, name: string) {
  let cur = voyageMultiplayerCursors.findByMultiIdSafe(multiId)
  voyageMultiplayerCursors.setName(cur, name)
}

export function extension_onOtherLeave(multiId: number) {
  let cur = voyageMultiplayerCursors.findByMultiIdSafe(multiId)
  if (cur) {
    voyageMultiplayerCursors.kill(cur)
  }
}

let _updateTimer = 0
let _updateTime = voyageMultiplayerCursors.mouseCursorUpdateTime
let _lastMou = { x: 0, y: 0 }

export function extension_onUpdate() {
  let dt = common.getUpdateDelta()
  _updateTimer += dt
  if (_updateTimer > _updateTime) {
    _updateTimer = 0
    let mou = voyageCamera.getAdjustedMousePosition()
    if (mou.x !== _lastMou.x && mou.y !== _lastMou.y) {
      voyageMessageCursor.sendMessageToOthers({
        x: mou.x,
        y: mou.y,
      })
    }
    _lastMou = mou
  }
}

// let _updateTimer = 0
// let _updateTime = voyageMultiplayerCursors.mouseCursorUpdateTime
// let _lastMou = { x: 0, y: 0 }
// export function update() {
//   if (!voyageTestParams.experimentalMultiplayer) {
//     return
//   }

//   let dt = common.getUpdateDelta()
//   _updateTimer += dt
//   if (_updateTimer > _updateTime) {
//     _updateTimer = 0

//     let mou = voyageCamera.getAdjustedMousePosition()

//     if (mou.x !== _lastMou.x && mou.y !== _lastMou.y) {
//       let m = messageWriter.create()
//       // messageWriter.writeBroadcast()
//       voyageMessageCursor.write(m, {
//         multiId: _multiId,
//         x: mou.x,
//         y: mou.y,
//       })
//       sendMessage(m)
//       // send('chat|' + 'm' + '|' + Math.floor(mou.x) + '|' + Math.floor(mou.y))
//     }
//     _lastMou = mou
//   }
// }

export function extension_sendWorldState(multiId: number) {
  if (getIsHost()) {
  }
}

export function extension_process(m: IMessageWriter, skipFrom: boolean) {
  voyageMessages.process(m, skipFrom)
}

export function extension_onVersionFail(
  serverVersion: string,
  yourVersion: string,
) {
  voyageUiMessage.setText(
    'A new version is available!',
    'Please download the latest version ' +
      serverVersion +
      ' to continue. ' +
      '\n\nYour version: ' +
      yourVersion,
  )
  voyageUiMessage.setOpen(true, () => {
    window.open(
      'https://www.keepflyinggames.com/games/keep-flying-together/latest-version',
    )
  })
}
